import React from "react";
import { Link } from "react-router-dom";
import "./Process.css";

const Process = () => {
  return (
    <section className="process mt-5 mt-md-0">
      <div className="container">
        <div className="section-title-reverse text-center mb-3">
          <h2>Jak umówić się na wizytę?</h2>
          <p className="additional-text">
          Profesjonalna pomoc w trzech prostych krokach.
          </p>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-12 d-flex align-items-stretch">
            <div className="content">
              <div className="top-part">
                <span className="step-number">1</span>
                <h4>Zarejestruj się</h4>
              </div>
              <div className="bottom-part">
                <small className="text-secondary">Rejestracja</small>
                <p>
                  Załóż konto na naszej platformie 
                  <br></br>– zajmie Ci to tylko chwilę, a otworzy drzwi do świata specjalistycznej diagnostyki.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <div className="content mt-xl-0">
              <div className="top-part">
                <span className="step-number">2</span>
                <h4>Wybierz specjalistę i termin</h4>
              </div>
              <div className="bottom-part">
                <small className="text-secondary">Umawianie wizyty</small>
                <p>
                  Elastyczne godziny i szeroka dostępność pozwalają Ci dopasować diagnozę do Twojego planu dnia.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <div className="content mt-xl-0">
              <div className="top-part">
                <span className="step-number">3</span>
                <h4>Otrzymujesz specjalistyczną pomoc</h4>
              </div>
              <div className="bottom-part">
                <small className="text-secondary">Wizyta</small>
                <p>
                  Po konsultacji otrzymujesz szczegółową opinię diagnostyczną, która pomoże Ci podjąć dalsze kroki w kierunku zdrowia.
                </p>
              </div>

              <div className="text-center">
                <Link to="/umow-wizyte" className="btn-get-started scrollto">
                  Umów wizytę
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
